import { render, staticRenderFns } from "./add_receipts_dialog.vue?vue&type=template&id=553850e2&scoped=true"
import script from "./add_receipts_dialog.vue?vue&type=script&lang=js"
export * from "./add_receipts_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_receipts_dialog.vue?vue&type=style&index=0&id=553850e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553850e2",
  null
  
)

export default component.exports